import {
  getPbsAPAC,
  getPbsAPACReseller,
  getPbsEU,
  getPbsEUReseller,
  getPbsJP,
  getPbsJPReseller,
  getPbsUS,
  getPbsUSReseller,
} from '~/src/dash/resellers/utils/importResellerConfig';

export function parseEndpointURL(url: string): { [key: string]: string } {
  const endpointMap: { [key: string]: string } = {};
  const endpointURL = '/v1/s2s-hb?';
  let pbsEndpoint = '';

  // Regular domains
  const pbsEndpointUSURL = getPbsUS() + endpointURL;
  const pbsEndpointEUURL = getPbsEU() + endpointURL;
  const pbsEndpointAPACURL = getPbsAPAC() + endpointURL;
  const pbsEndpointJPURL = getPbsJP() + endpointURL;

  // Reseller domains
  const pbsEndpointUSResellerURL = getPbsUSReseller() + endpointURL;
  const pbsEndpointEUResellerURL = getPbsEUReseller() + endpointURL;
  const pbsEndpointAPACResellerURL = getPbsAPACReseller() + endpointURL;
  const pbsEndpointJPResellerURL = getPbsJPReseller() + endpointURL;

  if (url.indexOf(pbsEndpointUSURL) > -1) {
    pbsEndpoint = pbsEndpointUSURL;
  } else if (url.indexOf(pbsEndpointEUURL) > -1) {
    pbsEndpoint = pbsEndpointEUURL;
  } else if (url.indexOf(pbsEndpointAPACURL) > -1) {
    pbsEndpoint = pbsEndpointAPACURL;
  } else if (url.indexOf(pbsEndpointJPURL) > -1) {
    pbsEndpoint = pbsEndpointJPURL;
  } else if (url.indexOf(pbsEndpointUSResellerURL) > -1) {
    pbsEndpoint = pbsEndpointUSResellerURL;
  } else if (url.indexOf(pbsEndpointEUResellerURL) > -1) {
    pbsEndpoint = pbsEndpointEUResellerURL;
  } else if (url.indexOf(pbsEndpointAPACResellerURL) > -1) {
    pbsEndpoint = pbsEndpointAPACResellerURL;
  } else if (url.indexOf(pbsEndpointJPResellerURL) > -1) {
    pbsEndpoint = pbsEndpointJPResellerURL;
  }

  (url.split(pbsEndpoint)[1] || '').split('&').forEach((kv: string) => {
    const kvpair = kv.split('=');
    endpointMap[kvpair[0]] = kvpair[1];
  });

  ['site_id'].forEach((key: string) => {
    if (key in endpointMap) {
      delete endpointMap[key];
    }
  });

  return endpointMap;
}

export function parseInventoryRouteEndpointURL(url: string): { [key: string]: string } {
  const endpointMap: { [key: string]: string } = {};
  const endpointURL = '/v1/inventory_route?';
  let pbsEndpoint = '';
  const pbsEndpointUSURL = getPbsUS() + endpointURL;
  const pbsEndpointEUURL = getPbsEU() + endpointURL;
  const pbsEndpointAPACURL = getPbsAPAC() + endpointURL;

  if (url.indexOf(pbsEndpointUSURL) > -1) {
    pbsEndpoint = pbsEndpointUSURL;
  } else if (url.indexOf(pbsEndpointEUURL) > -1) {
    pbsEndpoint = pbsEndpointEUURL;
  } else if (url.indexOf(pbsEndpointAPACURL) > -1) {
    pbsEndpoint = pbsEndpointAPACURL;
  }

  (url.split(pbsEndpoint)[1] || '').split('&').forEach((kv: string) => {
    const kvpair = kv.split('=');
    endpointMap[kvpair[0]] = kvpair[1];
  });

  ['inventory_route_id'].forEach((key: string) => {
    if (key in endpointMap) {
      delete endpointMap[key];
    }
  });

  return endpointMap;
}
